module.exports = __webpack_public_path__ + "static/media/image-1200.2c0f99c5.jpg";